import React, { useContext, useEffect, useState } from "react";
import { Fragment } from 'react';
import TopArroow from "../../../../resources/console/images/icon/top_arrow.svg";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../components/AppProvider";
import useStore from "../../../../modules/utils/store";
export const Footer = (props) => {
  const { auth, iam } = useContext(AppContext);
  const { siteInfo } = useStore();
  const { footerClass, eventInfo } = props;
  const [termsInfo, setTermsInfo] = useState(null);
  const [openModal, setOpenModal] = useState(null); 
  const showTerms = (type, e) => {
    if (e) e.preventDefault();
    $("body").css("overflow", "hidden");
    if (type === "termsUseAgree")
      setTermsInfo({ title: "사이트이용약관", content: siteInfo?.memTermsUseForm });
    else if (type === "termsPrivateAgree")
      setTermsInfo({
        title: "개인정보처리방침",
        content: siteInfo?.memTermsPrivacyForm,
      });
    else if (type === "termsMarket")
      setTermsInfo({
        title: "마케팅정보 수신동의",
        content: siteInfo?.memTermsMarketForm,
      });
    else {
      setTermsInfo(null);
    }
  };

  const modalClose = () => {
    setTermsInfo(null);
    setOpenModal(false);
    $("body").css("overflow", "auto");
  };

  const linkRel = () => { 
    window.open("https://nedrug.mfds.go.kr/pbp/CCBBB01/getItemDetail?itemSeq=201601746")
  }
  
  useEffect(() => {
    const openModalHandler = function (e) {
      e.preventDefault();
      $("body").css("overflow", "hidden");
      setOpenModal(true);
    };
    $("#openModal").click(openModalHandler);
    return () => {
      $("#openModal").off("click", openModalHandler);
    };
  }, []);
  return (
    <footer id="footer">
      <div className="footer-arrow-wrap">
        <button type="button" className="go-to-top">
            <img src={TopArroow} alt="탑버튼" />
            <span>TOP</span>
        </button>
      </div>
      {!['MEDIGATE','ICOD','GSK'].includes(iam?.targetType) && (<>
      <div className="footer_inform_cont">
        <div className="wid_1180">
          <ul>
            {siteInfo?.subPageList.map((item, i) => (
              <Fragment key={i}>
                {item.isShortcutShow == 1 && (
                  item.pageType == "LINK" ? (
                    <li>
                      <a href={`https://${item.link}`} className="link" target={item.openType == "POPUP" ? "_blank" : ""} >
                        <span>{item?.name}</span>
                      </a>
                    </li>
                  ) : (
                    <li>
                      <a href={`/#/site/${siteInfo.idx}/subpage/${item.pageId}`} className="link" target={item.openType == "POPUP" ? "_blank" : ""} >
                        <span>{item?.name}</span>
                      </a>
                    </li>
                  )
                )}
              </Fragment>
            ))}
          </ul>
        </div>
      </div>
      </>)}
      <div className="footer">
        <div className="wid_1180">
          <pre className="ft_info">
            <div dangerouslySetInnerHTML={{ __html: siteInfo?.footer?.replace(/\n/g,'') }} />
          </pre>
          {iam?.targetType == "MEMBER" && siteInfo?.memberFooterCheck === "Y" ? (
            <div className="ft_info2" style={{ marginTop: "30px" }}>
              <a onClick={showTerms.bind(this, "termsPrivateAgree")}>개인정보처리방침.</a>
              <a onClick={showTerms.bind(this, "termsUseAgree")}>이용약관</a>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {termsInfo && (
        <Fragment>
          <div className="ft_modal_container">
            <div className="ft_modal_header">
              <div>
                <h2>{termsInfo?.title}</h2>
                <button
                  className="close_btn"
                  href=""
                  onClick={(e) => {
                    e.preventDefault();
                    modalClose();
                  }}
                  >
                  <img src="https://cdn.onoffevent.com/common/icon_close.svg" />
                </button>
              </div>
            </div>
            <div className="ft_modal_content">
              <div dangerouslySetInnerHTML={{ __html: termsInfo?.content }} />
            </div>
          </div>
          <div className="modal_bg on"></div>
      </Fragment>
      )}
      {openModal && (
        <div className="modal_container">
          <button className="modal_close" onClick={modalClose}><img src="https://cdn.onoffevent.com/common/icon_close.svg" alt="닫기"/></button>
          <div className="modal_mid">
            <h4>
              당신은 한국 GSK 웹 사이트에서
              다른 페이지로 이동하려고 하고 있습니다.<br/>
              이 링크를 클릭하면 다른 웹 사이트 또는 웹 채널로 이동하게 됩니다.
            </h4>
            <span>
              지금 이동하려는 페이지는 한국 GSK의 유관 사이트이거나
              한국 규정이 적용되지 않는 글로벌 GSK 사이트 또는 계열사일 수 있습니다.
              GSK가 관리하지 않거나 GSK가 소유하지 않은 제3자 사이트로 이동할 경우,
              GSK는 해당 사이트에서 제공하는 콘텐츠에 대해 책임지지 않습니다.
            </span>
          </div>
          <div className="btnBox">
            <button className="modalBtn cancelBtn" onClick={modalClose}>취소</button>
            <button className="modalBtn confirmBtn" onClick={linkRel}>계속</button>
          </div>
        </div>
      )}
    </footer>
  );
};
